module.exports = __webpack_public_path__ + "Nick Tang-bb87260e.png";